"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DevianArt = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M9.641475,20.670075 L11.207475,17.726325 L11.694975,17.399325 L17.254725,17.399325 L17.254725,12.904575 L14.190975,12.904575 L13.918725,12.576075 L17.085225,6.593325 L17.085975,6.595575 L17.259975,6.273075 L17.259975,3.000075 L13.956225,3.000075 L13.626225,3.330075 L12.069975,6.273825 L11.580975,6.600825 L6.021225,6.600825 L6.021225,11.095575 L9.077475,11.095575 L9.349725,11.422575 C9.307725,11.501325 5.788725,18.148575 6.009975,17.730075 L6.009975,21.000075 L9.312225,21.000075 L9.641475,20.670075 Z", fillRule: "evenodd" })));
};
DevianArt.displayName = 'DevianArt';
exports.default = DevianArt;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DevianArt.js.map